exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#vContainerStyle[data-v-d5f1fa94] {\n  height: 90vh;\n  overflow: auto;\n}\n", ""]);

// exports
